import React from 'react';
import NavMenu from './NavMenu';
import { Alert, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import ContactsIcon from '@mui/icons-material/People';
import TrainingsIcon from '@mui/icons-material/EventRounded';
import AdminIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/ExitToAppRounded';
import ProgramIcon from '@mui/icons-material/Gavel';
import ListIcon from '@mui/icons-material/List';

class Layout extends React.Component {

    handleToggleAlert = (e) => this.props.actions.dismissAlert(e.currentTarget.parentElement.getAttribute('alert-id'));

    getAlerts() {
        let alerts = [];

        this.props.alerts.forEach(alert => {
            const { status, statusText, message, title } = alert.toJS();
            if (status >= 500) {
                const displayMessage = `${status} - ${statusText || 'Error'} - ${message}`;
                alerts.push(
                    <Alert
                        alert-id={alert.get('traceId')}
                        color='danger'
                        isOpen={!alert.get('dismissed')}
                        toggle={this.handleToggleAlert}
                    >
                        {displayMessage}
                    </Alert>);
            }
            else if (status >= 400 && status < 500) {
                const displayMessage = `${status} - ${statusText || 'Error'} - ${message || title}`;
                alerts.push(
                    <Alert
                        alert-id={alert.get('traceId')}
                        color='danger'
                        isOpen={!alert.get('dismissed')}
                        toggle={this.handleToggleAlert}
                    >
                        {displayMessage}
                    </Alert>);
            }
            else {
                alerts.push(<Alert color='success'>{message}</Alert>);
            }
        });

        return alerts;
    }

    render() {
        return (
            <div className='layout'>
                <NavMenu {...this.props} />
                <div className='layout-content'>
                    {this.props.isAuthenticated && (
                        <Nav
                            style={{
                                width: '15em',
                                borderTopRightRadius: '30px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                            vertical
                            className='layout-nav d-flex pe-1 me-1'
                        >
                            <div style={{ flex: 1 }}>
                                {/*<NavItem key='Home'>*/}
                                {/*    <NavLink tag={Link} to='/home' className={`d-flex ${this.props.location.pathname === '/home' ? 'menuitem-highlighted' : ''}`}><ListIcon className='pe-1' />Dashboard</NavLink>*/}
                                {/*</NavItem>*/}
                                {/*<NavItem key='Trainings'>*/}
                                {/*    <NavLink tag={Link} to='/trainings' className={`d-flex ${this.props.location.pathname === '/trainings' ? 'menuitem-highlighted' : ''}`}><TrainingsIcon className='pe-1' />Calendar</NavLink>*/}
                                {/*</NavItem>*/}
                                <NavItem style={{ borderTopRightRadius: '30px' }} key='Programs'>
                                    <NavLink
                                        tag={Link}
                                        to='/programs'
                                        className={`d-flex ${this.props.location.pathname === '/programs' ? 'menuitem-underline' : ''}`}
                                    >
                                        <ProgramIcon className='pe-1' />Dashboard
                                    </NavLink>
                                </NavItem>
                                <NavItem key='Contacts'>
                                    <NavLink
                                        tag={Link}
                                        to='/contacts'
                                        className={`d-flex ${this.props.location.pathname === '/contacts' ? 'menuitem-underline' : ''}`}
                                    >
                                        <ContactsIcon className='pe-1' />Users
                                    </NavLink>
                                </NavItem>
                                <NavItem key='Admin'>
                                    <NavLink
                                        tag={Link}
                                        to='/admin'
                                        className={`d-flex ${this.props.location.pathname === '/admin' ? 'menuitem-underline' : ''}`}
                                    >
                                        <AdminIcon className='pe-1' />Admin
                                    </NavLink>
                                </NavItem>
                            </div>
                            <NavItem>
                                <NavLink
                                    tag={Link}
                                    className='d-flex'
                                    onClick={this.props.actions.logoutAPI}
                                    to="#"
                                >
                                    <LogoutIcon className='pe-1' />Logout
                                </NavLink>
                            </NavItem>
                            <span className='nav-link text-center' style={{ fontSize:'small' }}>{this.props.appVersion}</span>
                        </Nav>
                    )}
                    <div className='layout-content-container pl-1'>
                        {this.getAlerts()}
                        {this.props.children}
                    </div>
                </div>
            </div>

        );
    }
}

export default Layout;